const TOOLTIP_WIDTH = 200 // it has some extra space just in case
const TOOLTIP_HEIGHT = 80
const MARGIN = 10

export default function calculateOptimalPlacement(triggerElement) {
  if (!triggerElement) {
    return 'top'
  }

  const rect = triggerElement.getBoundingClientRect()
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  // Calculate available space in each direction
  const spaceTop = rect.top - MARGIN
  const spaceBottom = viewportHeight - rect.bottom - MARGIN
  const spaceLeft = rect.left - MARGIN
  const spaceRight = viewportWidth - rect.right - MARGIN

  // Calculate center point of the trigger element
  const triggerCenterX = rect.left + rect.width / 2
  const triggerCenterY = rect.top + rect.height / 2

  // Check if tooltip can fit fully in each direction
  // For top/bottom: tooltip is centered horizontally, need vertical space for height
  // and ensure horizontal edges (center ± width/2) are within viewport
  // For left/right: tooltip is centered vertically, need horizontal space for width
  // and ensure vertical edges (center ± height/2) are within viewport

  const halfTooltipWidth = TOOLTIP_WIDTH / 2
  const halfTooltipHeight = TOOLTIP_HEIGHT / 2

  const canPlaceTop =
    spaceTop >= TOOLTIP_HEIGHT &&
    triggerCenterX - halfTooltipWidth >= 0 &&
    triggerCenterX + halfTooltipWidth <= viewportWidth

  if (canPlaceTop) {
    return 'top'
  }

  const canPlaceBottom =
    spaceBottom >= TOOLTIP_HEIGHT &&
    triggerCenterX - halfTooltipWidth >= 0 &&
    triggerCenterX + halfTooltipWidth <= viewportWidth

  if (canPlaceBottom) {
    return 'bottom'
  }

  const canPlaceRight =
    spaceRight >= TOOLTIP_WIDTH &&
    triggerCenterY - halfTooltipHeight >= 0 &&
    triggerCenterY + halfTooltipHeight <= viewportHeight

  if (canPlaceRight) {
    return 'right'
  }

  const canPlaceLeft =
    spaceLeft >= TOOLTIP_WIDTH &&
    triggerCenterY - halfTooltipHeight >= 0 &&
    triggerCenterY + halfTooltipHeight <= viewportHeight

  if (canPlaceLeft) {
    return 'left'
  }

  // Fallback: use the direction with most space
  const spaces = [
    { place: 'top', space: spaceTop },
    { place: 'bottom', space: spaceBottom },
    { place: 'left', space: spaceLeft },
    { place: 'right', space: spaceRight },
  ]
  spaces.sort((a, b) => b.space - a.space)
  return spaces[0].place
}
